import { useFlags } from 'flagsmith/react';

import { ExpVariationColorValue, FeatureFlag } from 'app/api/services/site-configs/types';

export const useVariationCheckFeatureFlag = <T extends ExpVariationColorValue>(
  featureFlag: FeatureFlag,
  variationValue: T,
) => {
  const flagsmithFeatureFlag = useFlags([featureFlag]);

  return flagsmithFeatureFlag[featureFlag].value === variationValue
   || !flagsmithFeatureFlag[featureFlag].enabled;
};
